module.exports = __webpack_public_path__ + "static/assets/c76e7e79e896c5fe938983101b4f743f.png";